import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'fast-text-encoding/text';

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import App from './views/App'
import SimpleReactLightbox from 'simple-react-lightbox'
import {appliquerTheme} from './util/theme'

appliquerTheme()


ReactDOM.render(  <SimpleReactLightbox>
    <App />
</SimpleReactLightbox>, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
